import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';

import Container from 'components/Container';

const mock = [
  {
    image: '',
    description:
      ' After one year of experience at NPS, YPR the one and only word that comes to my mind is SATISFACTION. Here I am satisfied as a teacher, as an employee, as a colleague and as a parent. The environment in the school is highly motivating and encouraging for teachers as well as students. Students of elementary and secondary school are able to express themselves via visual images in art. Their creativity reaches the highest level when they integrate subjects like mathematics, science, literature with art and craft. The freedom to do new creative projects is giving us a platform to produce aesthetically incredible artworks. ',
    title: 'Dr. Bhumija Dipti Panchal',
    author: {
      name: 'Dr. Bhumija Dipti Panchal',
      avatar: '',
    },
  },
  {
    image: '',
    description: "It was always my ambition to be a teacher, after experiencing a handful of amazing teachers who inspired me. 'I am who I am' because of them. I wanted to do the same for children and have been blessed with that opportunity, here in NPS. Our school is just not about the status or prestige of being a branded name, its all about the quality education we offer. It takes hard work, effort and time to grow into a good teacher and thats what I am here for.I feel privileged to learn from and work with a dedicated and passionate team of teachers. My desire is to extend the same warmth, open-ness and professional courtesy to students, teacher and parents alike, that I was made to feel when I arrived.Helping cultivate young children's ideas and dreams is truly a joy and a profession that I am proud of.",
    title: 'Ms. Sridevi Rachur',
    author: {
      name: 'Ms. Sridevi Rachur',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description:
      'Education is the most powerful weapon which you can use to change the world... Nelson MandelaTo pass time with young people, fresh minds and ignite them... Its such a blessing to be in the teaching profession... The icing on the cake is to have such a wonderful atmosphere to work as provided in NPS, YPR... All the latest technology available whenever needed and a wonderful science lab... for demonstrating and conducting experiments... is a real treat!The first batch of students were well adapted to the conducive atmosphere of NPS...Proud to be here from the first year with full support from the management and colleagues... Best wishes for NPS-YPR ',
    title: 'Ms. Papiya Datta',
    author: {
      name: 'Ms. Papiya Datta',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description:
      ' NPS is an epitome of Discipline. Organisation and professionalism. This is the benchmark of every student and teacher of this esteemed institution.As a teaching faculty my experience has been very enriching. ',
    title: 'Ms. Karishma Rai',
    author: {
      name: 'Ms. Karishma Rai',
      avatar: '',
    },
    date: '',
  },
];

const CompanyValues = () => {
  const theme = useTheme();
  return (
    <Container>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        marginBottom={4}
      >
        <Box>
          <Typography fontWeight={700} variant={'h6'} gutterBottom>
            {/* Latest stories */}
          </Typography>
          <Typography color={'text.secondary'}>
            {/* Here’s what we’ve been up to recently. */}
          </Typography>
        </Box>
        <Box display="flex" marginTop={{ xs: 2, md: 0 }}>
          {/* <Box
            component={Button}
            variant="outlined"
            color="primary"
            size="large"
            marginLeft={2}
          >
            View all
          </Box> */}
        </Box>
      </Box>
      <Grid container spacing={4}>
        {mock.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Box
              component={'a'}
              href={''}
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                boxShadow={4}
                display={'flex'}
                flexDirection={'column'}
                sx={{ backgroundImage: 'none' }}
              >
             
                <Box component={CardContent} position={'relative'}>
                  <Typography variant={'h6'} gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
                <Box flexGrow={1} />
                <Box padding={2} display={'flex'} flexDirection={'column'}>
                  <Box marginBottom={2}>
                    <Divider />
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <Box display={'flex'} alignItems={'center'}>
                      <Avatar
                        src={item.author.avatar}
                        sx={{ marginRight: 1 }}
                      />
                      <Typography color={'text.secondary'}>
                        {item.author.name}
                      </Typography>
                    </Box>
                    <Typography color={'text.secondary'}>
                      {item.date}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CompanyValues;